/**
 * Created by TzuHsing on 2020-02-15
 */

import {
  GETADV_UPLOADEDLIST,
  GETADV_UNPUBLISHEDLIST,
  GETADV_UNCHECKLIST,
  GETADV_DELETEDLIST,
  GETADV_UNIONLIST,
} from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETADV_UPLOADEDLIST:
      return Object.assign({}, state, { adv_uploadedList: action.payload })
    case GETADV_UNPUBLISHEDLIST:
      return Object.assign({}, state, { adv_unpublishedList: action.payload })
    case GETADV_UNCHECKLIST:
      return Object.assign({}, state, { adv_uncheckList: action.payload })
    case GETADV_DELETEDLIST:
      return Object.assign({}, state, { adv_deletedList: action.payload })
    case GETADV_UNIONLIST:
      return Object.assign({}, state, { adv_unionList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/reduce.js